import React, { createContext, useState } from "react";
import { Services as ServicesType } from "../types/services";

interface Props {
    children: React.ReactNode
}

export interface IServicesContext {
    services: ServicesType | null;
    setServices: React.Dispatch<React.SetStateAction<ServicesType | null>>
}

export const ServicesContext = createContext<null | IServicesContext>(null);

export const ServicesProvider: React.FC<Props> = ({ children }) => {  
    const [services, setServices] = useState<ServicesType | null>(null);    
    
    const value: IServicesContext = {
        services,
        setServices
    };

    return (
        <ServicesContext.Provider
            value={value}
        >
            {children}
        </ServicesContext.Provider>
    );
};